export default __webpack_public_path__ + "static/media/004.f9f58fdb.jpg";